import { render } from "./Swap.vue?vue&type=template&id=f47a22ea&scoped=true"
import script from "./Swap.vue?vue&type=script&lang=ts"
export * from "./Swap.vue?vue&type=script&lang=ts"

import "./Swap.vue?vue&type=style&index=0&id=f47a22ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f47a22ea"

export default script